/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC, useState} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {MasterInit} from '../../_metronic/layout/MasterInit'
import {Login} from '../pages/admin-portal/Login'
import {AdminRoutes} from '../pages/admin-portal/AdminRoutes'
import HomePage from '../pages/home/HomePage'
import QuickOrderPage from '../pages/quick-order/OuickOrderPage'
import CheckoutPage from '../pages/checkout/CheckoutPage'
import OrderSummaryPage from '../pages/order-summary/OrderSummaryPage'
import {QuickOrderContextProvider} from '../context/QuickOrderContext'
import ConfirmOrderPage from './../pages/confirm-order/ConfirmOrderPage'
import { ForgotPassword } from '../modules/auth/components/ForgotPassword'
import { ResetPassword } from '../modules/auth/components/ResetPassword'

const Routes: FC = () => {
  // const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const [isAuthorized, setIsAuthorized] = useState(
    JSON.parse(localStorage.getItem('isAuthorized') as any)
  )
  // const [isAuthorized, setIsAuthorized] = useState(false)

  return (
    <QuickOrderContextProvider>
      <Switch>
        <Route exact path='/error' component={ErrorsPage} />
        <Route exact path='/logout' component={Logout} />

        <Route
          exact
          path="/"
          render={() => {
            if (isAuthorized) return <Redirect to="/dashboard" />
            else return <HomePage isAuthorized={isAuthorized} />
          }}
        />
        <Route
          exact
          path='/quick-order'
          render={() => <QuickOrderPage isAuthorized={isAuthorized} />}
        />
        {/* <Route
          exact
          path='/patio-builder'
          render={() => <PatioBuilderPage isAuthorized={isAuthorized} />}
        /> */}

        <Route exact path='/login' render={() => <Login setIsAuthorized={setIsAuthorized} />} />
        <Route exact path='/checkout' render={() => <CheckoutPage isAuthorized={isAuthorized} />} />
        <Route
          exact
          path='/order-summary'
          render={() => <OrderSummaryPage isAuthorized={isAuthorized} />}
        />
        <Route
          exact
          path='/confirm-order'
          render={() => <ConfirmOrderPage isAuthorized={isAuthorized} />}
        />
        <Route exact path='/forgot-password' render={() => <ForgotPassword />} />
        <Route exact path='/reset-password' render={() => <ResetPassword />} />
        {isAuthorized === true ? <AdminRoutes /> : <PrivateRoutes />}
      </Switch>
      <MasterInit />
    </QuickOrderContextProvider>
  )
}

export {Routes}
